import {
	Breakpoints,
	Container,
	ContainerPadding,
	Layout,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
	Image,
} from '@volkswagen-onehub/components-core';

import React, { useEffect } from 'react';
import { PortalContext } from '../../context/PortalContext';
import { getUserName } from '../../helpers/nameHelper';
import { ClubGallery } from './components/clubHome/clubGallery';
import { HelpContainer } from '../vehicleManager/components/help-container';
import { pageInPath } from '../../tracking/trackingHelper';
import { useTrackingManager } from '../../tracking/useTrackingManager';

export const PendingClubUser: React.FC<{}> = () => {
	const { portalService } = React.useContext(PortalContext);
	const userData = portalService.getPerson().getValue();
	const userName = getUserName(userData);

	const trackingManager = useTrackingManager();

	useEffect(() => {
		pageInPath('pending.app');
		trackingManager.trackClubVWGenericFeatureAppLoad({ contentId: 'pending' }, {}, { vehicle: [] });
	}, []);

	return (
		<Container
			data-testid="pending-user__section"
			wrap={'always'}
			padding={{ top: ContainerPadding.dynamic0200, bottom: ContainerPadding.dynamic0200 }}
		>
			<Layout
				data-testid="pendingUser-layout"
				appearance={{
					[Breakpoints.default]: [
						{ name: '.', columns: 7 },
						{ name: 'a', columns: 10 },
						{ name: '.', columns: 7 },
						{ name: '.', columns: 1 },
						{ name: 'b', columns: 22 },
						{ name: '.', columns: 1 },
						{ name: '.', columns: 0 },
						{ name: 'c', columns: 24 },
						{ name: '.', columns: 0 },
						{ name: '.', columns: 1 },
						{ name: 'd', columns: 22 },
						{ name: '.', columns: 1 },
					],
					[Breakpoints.b560]: [
						{ name: '.', columns: 8 },
						{ name: 'a', columns: 8 },
						{ name: '.', columns: 8 },
						{ name: '.', columns: 1 },
						{ name: 'b', columns: 22 },
						{ name: '.', columns: 1 },
						{ name: '.', columns: 0 },
						{ name: 'c', columns: 24 },
						{ name: '.', columns: 0 },
						{ name: '.', columns: 1 },
						{ name: 'd', columns: 22 },
						{ name: '.', columns: 1 },
					],
					[Breakpoints.b960]: [
						{ name: '.', columns: 10 },
						{ name: 'a', columns: 4 },
						{ name: '.', columns: 10 },
						{ name: '.', columns: 4 },
						{ name: 'b', columns: 16 },
						{ name: '.', columns: 4 },
						{ name: '.', columns: 0 },
						{ name: 'c', columns: 24 },
						{ name: '.', columns: 0 },
						{ name: '.', columns: 1 },
						{ name: 'd', columns: 22 },
						{ name: '.', columns: 1 },
					],
					[Breakpoints.b1280]: [
						{ name: '.', columns: 10 },
						{ name: 'a', columns: 4 },
						{ name: '.', columns: 10 },
						{ name: '.', columns: 6 },
						{ name: 'b', columns: 12 },
						{ name: '.', columns: 6 },
						{ name: '.', columns: 0 },
						{ name: 'c', columns: 24 },
						{ name: '.', columns: 0 },
						{ name: '.', columns: 3 },
						{ name: 'd', columns: 18 },
						{ name: '.', columns: 3 },
					],
					[Breakpoints.b1600]: [
						{ name: '.', columns: 11 },
						{ name: 'a', columns: 2 },
						{ name: '.', columns: 11 },
						{ name: '.', columns: 7 },
						{ name: 'b', columns: 10 },
						{ name: '.', columns: 7 },
						{ name: '.', columns: 0 },
						{ name: 'c', columns: 24 },
						{ name: '.', columns: 0 },
						{ name: '.', columns: 5 },
						{ name: 'd', columns: 14 },
						{ name: '.', columns: 5 },
					],
					[Breakpoints.b1920]: [
						{ name: '.', columns: 11 },
						{ name: 'a', columns: 2 },
						{ name: '.', columns: 11 },
						{ name: '.', columns: 7 },
						{ name: 'b', columns: 10 },
						{ name: '.', columns: 7 },
						{ name: '.', columns: 0 },
						{ name: 'c', columns: 24 },
						{ name: '.', columns: 0 },
						{ name: '.', columns: 6 },
						{ name: 'd', columns: 12 },
						{ name: '.', columns: 6 },
					],
					[Breakpoints.b2560]: [
						{ name: '.', columns: 11 },
						{ name: 'a', columns: 2 },
						{ name: '.', columns: 11 },
						{ name: '.', columns: 7 },
						{ name: 'b', columns: 10 },
						{ name: '.', columns: 7 },
						{ name: '.', columns: 2 },
						{ name: 'c', columns: 20 },
						{ name: '.', columns: 2 },
						{ name: '.', columns: 7 },
						{ name: 'd', columns: 10 },
						{ name: '.', columns: 7 },
					],
				}}
				allowOverflowingContent
			>
				<Container
					padding={{ bottom: ContainerPadding.dynamic0250 }}
					wrap={'always'}
					horizontalAlign={'center'}
					stretchContent
				>
					<Image
						src="https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-club/logo_club.svg"
						alt="Logo club VW"
					/>
				</Container>
				<Container verticalAlign={'center'} horizontalAlign={'center'} stretchContent>
					<Container padding={{ bottom: ContainerPadding.dynamic0130 }} horizontalAlign={'center'}>
						<Text
							appearance={TokenTextAppearance.headline400}
							textAlign={TextAlignment.center}
							color={TokenTextColor.primary}
						>
							{userName ? `¡${userName}, ya tienes un pie dentro!` : '¡Ya tienes un pie dentro!'}
						</Text>
					</Container>
					<Container
						padding={{ bottom: ContainerPadding.dynamic0250 }}
						horizontalAlign={'center'}
						verticalAlign={'center'}
						wrap={'always'}
					>
						<Text
							appearance={TokenTextAppearance.bigcopy100}
							textAlign={TextAlignment.center}
							color={TokenTextColor.primary}
							bold
						>
							Estamos validando tu perfil
						</Text>

						<Text
							appearance={TokenTextAppearance.bigcopy100}
							textAlign={TextAlignment.center}
							color={TokenTextColor.primary}
						>
							Vuelve en un par de días para descubrir lo que tenemos preparado para ti.
						</Text>
					</Container>
					<Container padding={{ bottom: ContainerPadding.dynamic0150 }} horizontalAlign={'center'}>
						<Text
							appearance={TokenTextAppearance.headline300}
							textAlign={TextAlignment.center}
							color={TokenTextColor.primary}
						>
							Estos son algunos de los beneficios que te esperan...
						</Text>
					</Container>
				</Container>

				<ClubGallery />

				<HelpContainer />
			</Layout>
		</Container>
	);
};
